(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "4d2700d1eb91db09de51374a9a6c2fad9bcf3f0c"
};